'use client';

import { c as _c } from "react/compiler-runtime";
import { useSegmentStandardTrack } from '../lib/useSegmentStandardTrack';
import type { FormProps } from './types';
type FormActionType = 'started' | 'field-interacted' | 'step-viewed' | 'step-submitted' | 'submitted' | 'error';
type FormActionFireProps = {
  formAction: FormActionType;
  stepName?: string;
  field?: string;
  fieldType?: string;
  fieldValue?: string | number;
  parentEventId?: string;
  eventId?: string;
  additionalAttributes?: Record<string, unknown>;
};
export const useFormAction = t0 => {
  const $ = _c(5);
  const {
    formName,
    sectionName,
    additionalAttributes
  } = t0;
  const track = useSegmentStandardTrack("Form Action");
  let t1;
  if ($[0] !== additionalAttributes || $[1] !== formName || $[2] !== sectionName || $[3] !== track) {
    t1 = (t2, callback) => {
      const {
        formAction,
        stepName,
        field,
        fieldType,
        fieldValue,
        parentEventId,
        eventId,
        additionalAttributes: fireAttributes
      } = t2;
      return void track({
        form_action: formAction,
        form_name: formName,
        step_name: stepName,
        field,
        field_type: fieldType,
        field_value: fieldValue,
        section_name: sectionName
      }, {
        eventId,
        parentEventId,
        additionalAttributes: {
          ...additionalAttributes,
          ...fireAttributes
        }
      })?.finally(() => {
        callback?.();
      });
    };
    $[0] = additionalAttributes;
    $[1] = formName;
    $[2] = sectionName;
    $[3] = track;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};